export default __webpack_public_path__ + "static/media/tabler-icon-writing-sign.d6666098.svg";